/**
 * Ortak durum/rol/platform etiketleri — Kullanicilar (MembersTable), Admin
 * (TenantTable) ve TenantSec ham backend enum degerlerini (ör. "active",
 * "tenant_admin", "ticimax") DOGRUDAN ekrana basiyordu (arayuz-denetim-
 * duzeltmeleri gorev madde 3). Ceviriler mumkun oldugunca MEVCUT tr.ts
 * anahtarlarindan (tenant_sec.status.*, kullanicilar.role.*) alinir — yalniz
 * eksik olanlar (status.*, platform.*) yeni eklendi. Bilinmeyen/beklenmeyen
 * bir deger gelirse (ör. backend yeni bir durum eklerse) OLDUGU GIBI
 * dondurulur — sessizce "—" ya da bos gostermek yerine en azindan ham deger
 * gorulebilir kalir.
 */
import { t, type TrKey } from "@/i18n";

const STATUS_KEYS: Record<string, TrKey> = {
  active: "tenant_sec.status.active",
  pending: "tenant_sec.status.pending",
  rejected: "tenant_sec.status.rejected",
  disabled: "status.disabled",
  setup: "status.setup",
  suspended: "status.suspended",
  archived: "status.archived",
};

const ROLE_KEYS: Record<string, TrKey> = {
  tenant_admin: "kullanicilar.role.tenant_admin",
  tenant_user: "kullanicilar.role.tenant_user",
};

const PLATFORM_KEYS: Record<string, TrKey> = {
  ticimax: "platform.ticimax",
  ikas: "platform.ikas",
  ideasoft: "platform.ideasoft",
  shopify: "platform.shopify",
};

/** Uyelik/tenant durumu (active/pending/rejected/disabled/setup/suspended/archived). */
const ORDER_STATUS_KEYS: Record<string, TrKey> = {
  confirmed: "order_status.confirmed",
  preparing: "order_status.preparing",
  shipped: "order_status.shipped",
  delivered: "order_status.delivered",
  cancelled: "order_status.cancelled",
  returned: "order_status.returned",
  refunded: "order_status.refunded",
  pending_payment: "order_status.pending_payment",
  payment_attempt: "order_status.payment_attempt",
  unknown: "order_status.unknown",
};

/** Kanonik siparis durumu (confirmed/preparing/...) → Turkce etiket; bilinmeyen metin aynen doner. */
export function orderStatusLabel(value: string | null | undefined): string {
  if (!value) return "—";
  const key = ORDER_STATUS_KEYS[String(value).toLowerCase()];
  return key ? t(key) : String(value);
}

export function statusLabel(value: string): string {
  const key = STATUS_KEYS[value];
  return key ? t(key) : value;
}

/** Uyelik rolu (tenant_admin/tenant_user). */
export function roleLabel(value: string): string {
  const key = ROLE_KEYS[value];
  return key ? t(key) : value;
}

/** Tenant platformu (ticimax/ikas). */
export function platformLabel(value: string): string {
  const key = PLATFORM_KEYS[value];
  return key ? t(key) : value;
}
